import { render } from "./modalList.vue?vue&type=template&id=0481fe0e"
import script from "./modalList.vue?vue&type=script&lang=js"
export * from "./modalList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__